import { createFileRoute } from "@tanstack/react-router";
import { PublicFooter, PublicHeader } from "@/components/public-layout";
import { SupportPageContent } from "@/components/support/SupportPageContent";
import {
	buildLocalizedSeoLinks,
	getLocalizedSeoUrls,
	ogImageUrl,
} from "@/lib/seo";

export const Route = createFileRoute("/support")({
	component: SupportPage,
	head: ({ matches }) => {
		const seoUrls = getLocalizedSeoUrls({
			matches,
			internalPath: "/support",
		});

		const title = "AgentReacher | Support";
		const description =
			"Get help with AgentReacher. Email us, join our WhatsApp community, or send us a message.";

		return {
			meta: [
				{ title },
				{ name: "description", content: description },
				{ property: "og:title", content: title },
				{ property: "og:description", content: description },
				{ property: "og:image", content: ogImageUrl("help") },
				{ property: "og:url", content: seoUrls.canonicalUrl },
				{ property: "og:type", content: "website" },
				{ name: "twitter:card", content: "summary_large_image" },
				{ name: "twitter:title", content: title },
				{ name: "twitter:description", content: description },
				{ name: "twitter:image", content: ogImageUrl("help") },
			],
			links: buildLocalizedSeoLinks({
				matches,
				internalPath: "/support",
			}),
		};
	},
});

function SupportPage() {
	return (
		<div className="flex min-h-svh flex-col bg-background text-foreground">
			<PublicHeader />
			<main className="relative z-10 flex-1">
				<div className="mx-auto max-w-6xl px-4 sm:px-6">
					<div className="marketing-line-stack flex flex-col overflow-hidden divide-y divide-border">
						<div className="rounded-md bg-white dark:bg-black px-6 py-10 sm:px-10 sm:py-12">
							<div className="mx-auto max-w-2xl">
								<SupportPageContent />
							</div>
						</div>
					</div>
				</div>
			</main>
			<PublicFooter showCta={false} />
		</div>
	);
}
